import { jsx } from "react/jsx-runtime";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { validateTidalLicense } from "../../base/index.js";
function ContentCopy(props) {
  return /* @__PURE__ */ jsx(
    ContentCopyIcon,
    {
      "data-testid": "ContentCopy",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ContentCopy",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
ContentCopy.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "ContentCopy"
};
validateTidalLicense();
export {
  ContentCopy
};
//# sourceMappingURL=ContentCopy.js.map
